import { httpClient } from '../api/http.client';
import type { 
  ReservationWithDetails,
  ReservationSource,
  ReservationFilters,
  ReservationsSummary
} from '../../domain/entities/Reservation';

export class ReservationRepository {
  async getReservationSources(): Promise<ReservationSource[]> {
    return await httpClient.get<ReservationSource[]>('/api/admin/reservations/sources');
  }

  async getActiveReservations(filters: ReservationFilters = {}): Promise<ReservationWithDetails[]> {
    const params = new URLSearchParams();
    
    if (filters.status) params.append('status', filters.status);
    if (filters.sourceId) params.append('sourceId', filters.sourceId.toString());
    if (filters.sku) params.append('sku', filters.sku);
    if (filters.orderId) params.append('orderId', filters.orderId);

    const queryString = params.toString();

    return await httpClient.get<ReservationWithDetails[]>(
      `/api/admin/reservations${queryString ? `?${queryString}` : ''}`
    );
  }

  async getReservationsByOrderId(orderId: string): Promise<ReservationWithDetails[]> {
    return await httpClient.get<ReservationWithDetails[]>(
      `/api/admin/reservations/order/${orderId}`
    );
  }

  async getReservationsSummary(): Promise<ReservationsSummary> {
    return await httpClient.get<ReservationsSummary>('/api/admin/reservations/summary');
  }
}

export const reservationRepository = new ReservationRepository();

